export default "__VITE_ASSET__DE1P46ZZ__"